import React, { useState, useEffect, useRef } from "react";
import myImage from "../../assets/arrow.svg";
import smartNotificationsImg1 from "../../assets/SlideUpCards_1.webp";
import smartNotificationsImg2 from "../../assets/SlideUpCards_2.webp";
import smartNotificationsImg3 from "../../assets/SlideUpCards_3.webp";
import smartNotificationsImg4 from "../../assets/SlideUpCards_4.webp";

import "../../Css/Real.css";

const SlideUpCards = () => {
  const [currentCard, setCurrentCard] = useState(1);
  const sectionRef = useRef(null);
  const cardRefs = useRef([]);

  const sectionData = [
    {
      id: 1,
      title: "Smart Route Optimization",
      text: (
        <>
          <strong className="">
            We find the fastest way — so you don’t have to
          </strong>{" "}
          <br />
          <br />
          No more wasted time or fuel on roundabout routes. Packky (powered by
          Chaafo) uses smart route planning to make sure your deliveries take
          the quickest, most efficient path.
          <br />
          <br />
          It helps you avoid delays, reduce costs, and get things done faster.
          Whether it’s a single drop or multiple stops, your deliveries move
          smoothly and on time.
        </>
      ),
      images: smartNotificationsImg1,
    },
    {
      id: 2,
      title: "Order Synchronization",
      text: (
        <>
          <strong className="">
            All your deliveries, organized in one place
          </strong>{" "}
          <br />
          <br />
          If you're managing multiple deliveries every day, we’ve got your back.
          Packky (powered by Chaafo) brings all your orders together in one
          dashboard, so you can schedule, track, and repeat without jumping
          between tools.
          <br />
          <br />
          Whether you're delivering to customers, vendors, or branches,
          everything stays neat, synced, and easy to manage.
        </>
      ),
      images: smartNotificationsImg2,
    },
    {
      id: 3,
      title: "Flexible Vehicle Options",
      text: (
        <>
          <strong className="">
            Choose the right vehicle for every delivery
          </strong>{" "}
          <br />
          <br />
          Different deliveries need different rides. With Packky (powered by
          Chaafo), you can choose from two-wheelers for small packages,
          three-wheelers for medium loads, or mini-trucks for bigger deliveries.
          <br />
          <br />
          We’ll help you pick what fits best based on size, weight, and urgency
          — saving you both time and cost.
        </>
      ),
      images: smartNotificationsImg3,
    },
    {
      id: 4,
      title: "Real-Time Tracking",
      text: (
        <>
          <strong className="">Stay updated every step of the way</strong>{" "}
          <br />
          <br />
          With Packky (powered by Chaafo), you always know where your parcel is.
          From the moment it's picked up to the moment it’s delivered, real-time
          tracking keeps you and your customers in the loop.
          <br />
          <br />
          Whether you're sending something across town or across multiple zones,
          you'll get live updates so you're never left guessing. It’s reliable,
          transparent, and made to build trust with every delivery.
        </>
      ),
      images: smartNotificationsImg4,
    },
  ];

  const gradientClasses = [
    "gradient-blue",
    "gradient-orange",
    "gradient-red",
    "gradient-purple",
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current || cardRefs.current.length === 0) return;

      let newCardIndex = 0;
      const screenHeight = window.innerHeight;

      const viewportCenterSmallScreen =
        screenHeight < 600 ? screenHeight / 5 : screenHeight / 7;
      const viewportCenterLargeScreen =
        screenHeight < 600 ? screenHeight / 3 : screenHeight / 6;

      cardRefs.current.forEach((cardRef, index) => {
        if (!cardRef) return;
        const rect = cardRef.getBoundingClientRect();

        if (
          (rect.top <= viewportCenterSmallScreen &&
            rect.bottom >= viewportCenterSmallScreen) ||
          (rect.top <= viewportCenterLargeScreen &&
            rect.bottom >= viewportCenterLargeScreen)
        ) {
          newCardIndex = index;
        }
      });

      setCurrentCard(newCardIndex + 1);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section ref={sectionRef} id="real-time-section">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="w-full">
          <div className="font-sans">
            {/* Heading */}
            <div className="section-heading-container sticky top-[50px] z-0 mt-5 mb-2 text-center lg:top-[80px] lg:text-left">
              <h5 className="section-heading font-bold !text-[28px] text-[#212529] !sm:text-[24px] !md:text-[26px] !lg:text-[28px] leading-tight">
                Deliver More, Stress Less with Packky (powered by Chaafo)
              </h5>
            </div>

            <div className="section-container">
              <div className="sticky-container relative z-10 isolate mb-6 mt-12 space-y-6 sm:mt-10 sm:space-y-7 md:mt-12 md:space-y-8 lg:mt-14">
                {sectionData.map((card, index) => (
                  <div
                    key={card.id}
                    ref={(el) => (cardRefs.current[index] = el)}
                    className={`sticky-card ${gradientClasses[index]} relative z-20 w-full overflow-hidden rounded-[24px] bg-clip-padding p-4 text-[18px] md:text-[18px] sm:p-5 md:p-6 lg:p-8`}
                  >
                    {/* HEADER */}

                    <div className="card-header flex flex-row items-center justify-between gap-2">
                      <div className="header-left flex min-w-0 items-center gap-2">
                        <button className="icon-button shrink-0">
                          <img
                            src={myImage}
                            alt="Packky Logo"
                            className="icon-image h-8 w-8 object-contain sm:h-10 sm:w-10 md:h-12 md:w-12"
                          />
                        </button>

                        <h5 className="card-title truncate text-[13px] font-semibold leading-tight sm:text-[16px] md:text-[22px]">
                          {card.title || "Default Heading"}
                        </h5>
                      </div>

                      <div className="shrink-0">
                        <button className="counter-button whitespace-nowrap px-2 py-1 text-[11px] sm:text-sm md:text-base">
                        {index + 1} / {sectionData.length}
                        </button>
                      </div>
                    </div>

                    {/* BODY */}
                    <div className="card-body-container mt-5">
                      <div className="card-body">
                        <div className="flex flex-col-reverse items-center gap-6 md:flex-row md:items-center md:gap-8 lg:gap-10">
                          {/* TEXT */}
                          <div className="order-2 w-full md:order-1 md:w-1/2">
                            <div className="card-text-container text-center md:text-left">
                              <p className="card-text text-[14px] leading-7 sm:text-[15px] md:text-[16px]">
                                {card.text}
                              </p>
                            </div>
                          </div>

                          {/* IMAGE */}
                          <div className="order-1 w-full md:order-2 md:w-1/2">
                            <div className="image-container flex w-full justify-end md:justify-end">
                              <div className="image-wrapper w-full max-w-[320px] sm:max-w-[420px] md:max-w-[500px] lg:max-w-[620px] xl:max-w-[700px]">
                                <img
                                  src={card.images}
                                  alt={card.title}
                                  className="card-image h-auto w-full object-contain"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SlideUpCards;